import { updateSettings } from "api";
import { useGetSettings } from "api/queries/user/useGetSettings";
import { useRef } from "react";

type ColumnOrderPersistorOptionsType = {
  moduleKey: "quick_request" | "quote_request" | "shipment" | "invoice";
};

export default function useColumnOrderPersistor(options: ColumnOrderPersistorOptionsType) {
  const { moduleKey } = options;
  const { data: userSetting, refetch: refetchUserSettings } = useGetSettings({ refetchOnMount: false });
  const columnOrderAbortController = useRef<AbortController | null>(null);

  const onColumnOrderChange = (newColumnOrder: string[]) => {
    if (columnOrderAbortController.current?.abort) {
      columnOrderAbortController.current.abort();
    }
    columnOrderAbortController.current = new AbortController();
    const updatedSettings = {
      ...userSetting,
      list_column_arrangements: {
        ...userSetting?.list_column_arrangements,
        [moduleKey]: newColumnOrder,
      },
    };
    updateSettings(updatedSettings, { signal: columnOrderAbortController.current.signal }).then(() => {
      refetchUserSettings();
    });
  };

  return {
    persistedColumnOrder: userSetting?.list_column_arrangements?.[moduleKey] || [],
    onColumnOrderChange,
  };
}
